import { getFromLocalStorage } from '../../hooks/useLocalStorage';
import { UPDATE_BULK_POLICY_PAYLOAD , UPDATE_BULK_POLICY_PAYLOAD_SUCCESS , UPDATE_BULK_POLICY_PAYLOAD_RESET, UPDATE_BULK_POLICY_PAYLOAD_ERROR, SAVE_VALIDATION_DATA, SAVE_DISCOUNT_DATA, UPDATE_DISCOUNTED_RECORDS, CLEAR_DISCOUNT_DATA, UPDATE_VALIDATION_RECORDS, SAVE_PROPOSER_DETAILS, SAVE_BULK_FILE_URL, SAVE_BULK_QUOTATION_NUMBER, SAVE_ADDON_DATA, CLEAR_ADDON_DATA } from '../actionTypes'


export const BulkPolicyInitialState = {
    generateQuote: {
        company_id:'',
        policyType: '',
        documentVariant: '',
        bulkUpload: '',
    },
    // Validation and discount data
    validationData: {
        successLog: [],
        totalPremium: 0,
        availableBalance: 0,
        errorCount: 0,
        errorFile: null, // To store any error file generated during validation
        successCount: 0,
        message: '',
        partnership: null,
        bulkFileUrl: '', // Store the uploaded Excel file URL
        bulkQuotationNumber: '', // Store the quotation number for bulk upload
    },
    discountData: {
        discountPercentage: 0,
        discountedRecords: null,
    },
    addonData: {
        selectedServices: {},       // { [recordId]: [addon objects] }
        additionalCost: {},         // { [recordId]: number }
        individualAddonCosts: {},   // { [recordId]: { [serviceKey]: cost } }
    },
}

export default (state = BulkPolicyInitialState, action) => {
    switch (action.type) {
        case UPDATE_BULK_POLICY_PAYLOAD:
            return { ...state, ...action.payload?.policy };
        case UPDATE_BULK_POLICY_PAYLOAD_SUCCESS:
            return { ...state, ...action.payload };
        case UPDATE_BULK_POLICY_PAYLOAD_ERROR:
            return { ...state, error: action.payload };
        case SAVE_VALIDATION_DATA:
            return { 
                ...state, 
                validationData: {
                    ...state.validationData, // Preserve existing fields like bulkFileUrl and proposerCommonDetails
                    successLog: action.payload.successLog || [],
                    totalPremium: action.payload.totalPremium || 0,
                    availableBalance: action.payload.availableBalance || 0,
                    errorCount: action.payload.errorCount || 0,
                    errorFile: action.payload.errorFile || null,
                    successCount: action.payload.successCount || 0,
                    message: action.payload.message || '',
                    partnership: action.payload.partnership || null,
                }
            };
        case SAVE_DISCOUNT_DATA:
            return { 
                ...state, 
                discountData: {
                    discountPercentage: action.payload.discountPercentage || 0,
                    discountedRecords: action.payload.discountedRecords || null,
                }
            };
        case UPDATE_DISCOUNTED_RECORDS:
            return { 
                ...state, 
                discountData: {
                    ...state.discountData,
                    discountedRecords: action.payload
                }
            };
            case UPDATE_VALIDATION_RECORDS:
                // payload expected to be an array of records (possibly with addon/member premium updated)
                const records = Array.isArray(action.payload) ? action.payload : [];
                // Recompute total premium from records: prefer discounted premium if available, else member_premium or base_premium
                const newTotal = records.reduce((sum, r) => {
                    const v = (r.discount && r.discount.premiumAfterDiscount) || r.documentDetails?.member_premium || r.documentDetails?.base_premium || 0;
                    return sum + Number(v || 0);
                }, 0);
                return {
                    ...state,
                    validationData: {
                        ...state.validationData,
                        successLog: records,
                        totalPremium: newTotal,
                        // keep existing proposer common details if any – no change here
                    }
                };
        case SAVE_PROPOSER_DETAILS:
            return {
                ...state,
                validationData: {
                    ...state.validationData,
                    proposerCommonDetails: action.payload || {},
                }
            };
        case SAVE_BULK_FILE_URL:
            return {
                ...state,
                validationData: {
                    ...state.validationData,
                    bulkFileUrl: action.payload || '',
                }
            };
        case SAVE_BULK_QUOTATION_NUMBER:
            return {
                ...state,
                validationData: {
                    ...state.validationData,
                    bulkQuotationNumber: action.payload || '',
                }
            };
        case CLEAR_DISCOUNT_DATA:
            return { 
                ...state, 
                discountData: {
                    discountPercentage: 0,
                    discountedRecords: null,
                }
            };
        case SAVE_ADDON_DATA:
            return {
                ...state,
                addonData: {
                    ...state.addonData,
                    ...action.payload,
                }
            };
        case CLEAR_ADDON_DATA:
            return {
                ...state,
                addonData: {
                    selectedServices: {},
                    additionalCost: {},
                    individualAddonCosts: {},
                }
            };
        case UPDATE_BULK_POLICY_PAYLOAD_RESET:
            return { ...BulkPolicyInitialState };
        default: return state;
    }
}